export default __webpack_public_path__ + "static/media/vatted-recruiters.eeb928a3.svg";